import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestBase } from './request-base';

@Injectable()
export class DebugService extends RequestBase {
    BasePath = 'api/debug';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    GetWorkflow(id, parent): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/GetWorkflow?id=' + id + '&parent=' + parent, this.options);
    }

    GetAllWorkflows(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/GetAllWorkflows', this.options);
    }

    /**
     * Der Wert einer Variablen eines angehaltenen **Service**-Workflows.
     *
     * Der Schritt-Status traegt nur noch Namen, Typen und kurze Vorschauen;
     * einen Wert holt die Konsole erst, wenn jemand ihn aufklappt. Gilt nur
     * fuer Service-Workflows -- bei einem Client-Workflow liegt der Wert in
     * einem anderen Browser, dort fragt WorkflowDebugHelper.RequestVariable
     * ueber den Debug-Kanal.
     */
    GetVariable(runID: string, name: string): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/GetVariable?runId=' + runID
            + '&name=' + encodeURIComponent(name), this.options);
    }
}
